import { Add, Cancel, Link, Remove, Save } from '@mui/icons-material';
import { Box, Button, Dialog, DialogContent, DialogTitle, Divider, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { ReportsServicesRpsb } from '../../../../services/api/reports/ReportsServicesRpsb';

type Recomendacao = {
    recomendacao: string,
    prazo: string,
    uuid?: string,
    plano_acao: {
        acao: string,
        data_limite_seguranca: string,
        descricao: string,
        responsavel_principal: string,
        npa: string,
        id_barragem: string,
        finalizado: boolean,
        codigo_anomalia: string,
        uuid?: string;
        status?: string;
        anomalia?: {  // Tornando opcional
            data_inspecao: string,
            item: string,
            situacao: string,
            magnitude: string,
            npa: string,
            id_barragem: string,
            id_estrutura: string,
            observacoes_gerais: string,
            fluxo: string,
            data_criacao?: string;
            codigo_anomalia?: string;
            uuid?: string;
        }
    }
}

type PlanoAcao = {
    acao: string,
    data_limite_seguranca: string,
    descricao: string,
    responsavel_principal: string,
    npa: string,
    id_barragem: string,
    finalizado: boolean,
    codigo_anomalia: string,
    anomalia?: Anomalia
}

type Anomalia = {
    data_inspecao: string,
    item: string,
    situacao: string,
    magnitude: string,
    npa: string,
    id_barragem: string,
    id_estrutura: string,
    observacoes_gerais: string,
    fluxo: string,
    data_criacao: string,
    origem: string,
}

type Estrutura = keyof typeof anomaliasType;

const anomaliasType = {
    Acesso: [
        'Erosões Deslizamentos nas vias',
        'Acúlumo de Água',
        'Defeitos nos dispositivos de drenagem',
        'Defeitos na Sinalização',
        'Restrição nos acessos',
        'Outro',
    ],
    Crista: [
        'Fissura / Trinca',
        'Ausência de proteção',
        'Subsidências, depressões ou buracos',
        'Erosões ou ravinamentos superficiais',
        'Vegetação arbórea ou arbustiva',
        'Acúmulo de água (Inclinação)',
        'Defeito nos dispositivos de Drenagem',
        'Defeitos na leira',
        'Presença de animais (Formigueiros,tocas,etc.)',
        'Outro',
    ],
    'Talude de montante': [
        'Erosões ou ravinamentos',
        'Fissura / trinca',
        'Ausência de proteção',
        'Vegetação falha ou crescimento irregular',
        'Rip-Rap danificado ou incompleto',
        'Conformação inadequada',
        'Presença de animais (Formigueiros, tocas, etc.)',
        'Escorregamentos ou abatimentos',
        'Outro',
    ],
    'Talude de jusante': [
        'Erosões ou ravinamentos',
        'Vegetação falha ou crescimento irregular',
        'Conformação inadequada',
        'Presença de animais (Formigueiros, tocas, etc.)',
        'Escorregamentos ou abatimentos',
        'Áreas úmidas, encharcadas/ fofas ou surgência',
        'Outro',
    ],
    'Ombreira Direita': [
        'Erosões ou ravinamentos',
        'Desprendimento de blocos',
        'Fraturamento',
        'Deslizamento / rastejo',
        'Vegetação densa',
        'Áreas úmidas, encharcadas / fofas ou surgências',
        'Alteração no solo / rocha',
        'Presença de animais (Formigueiros, tocas, etc)',
        'Movimento de massas dos taludes',
        'Outro',
    ],
    'Ombreira Esquerda': [
        'Erosões ou ravinamentos',
        'Desprendimento de blocos',
        'Fraturamento',
        'Deslizamento / rastejo',
        'Vegetação densa',
        'Áreas úmidas, encharcadas / fofas ou surgências',
        'Alteração no solo / rocha',
        'Presença de animais (Formigueiros, tocas, etc)',
        'Movimento de massas dos taludes',
        'Outro',
    ],
    'Área de justante ao pé da barragem': [
        'Erosões ou ravinamentos',
        'Desprendimento de blocos',
        'Fraturamento',
        'Deslizamento / rastejo',
        'Vegetação densa',
        'Áreas úmidas, encharcadas/fofas ou surgências',
        'Alteração no solo / rocha',
        'Presença de animais (Formigueiros, tocas, etc)',
        'Movimento de massas dos taludes',
        'Outro',
    ],
    Reservatório: [
        'Praia inadequada',
        'Borda livre insuficiente',
        'Deslizamento / desmoronamento nas margens',
        'Assoreamento',
        'Presença de animais (Formigueiros, tocas, etc.)',
        'Vegetação flutuante em excesso',
        'Troncos de árvores',
        'Outro',
    ],
    'Tomada d\'água': [
        'Trincas ou Fissuras',
        'Desplacamento ou foliações',
        'Infiltrações',
        'Ferragem exposta',
        'Obstrução',
        'Reação Álcali-Agregado (RAA)',
        'Ausência de boias de sinalização próximo à tomada',
        'Outro',
    ],
    Vertedouro: [
        'Trincas ou Fissuras',
        'Desplacamento ou foliações',
        'Infiltrações',
        'Deslocamentos',
        'Turbidez elevada',
        'Ferragem exposta',
        'Obstrução',
        'Reação Álcali-Agregado (RAA)',
        'Necessidade de Limpeza',
        'Outro',
    ],
    'Sistema de drenagem superficial': [
        'Canaletas danificadas / obstruídas',
        'Escada descida d\'água danificada',
        'Caixa de passagem assoreada',
        'Caixa de passagem danificada',
        'Canal periférico danificado/ obstr.',
        'Surgência (especificar estrutura)',
        'Erosão (especificar estrutura)',
        'Canais periféricos',
        'Outro',
    ],
    'Drenagem interna / Dreno fundo': [
        'Carreamento de finos',
        'Turbidez elevada',
        'Bacia de dissipação assoreada',
        'Dreno afogado',
        'Presença de ferro bactérias',
        'Outro',
    ],
    Instrumentação: [
        'Acessos precários',
        'Ausência de instrumentos',
        'Falta de proteção dos instrumentos',
        'Instrumento sem identificação',
        'Régua linimétrica ilegível',
        'Régua linimetrica não instalada',
        'Defeitos nos piezômetros',
        'Defeitos nos indicadores de nível d\'água',
        'Defeitos nos poços de alívio',
        'Defeitos nos medidores de vazão',
        'Defeitos nos marcos superficiais/ def. condutos',
        'Defeitos nas placas de recalque',
        'Defeitos nos inclinômetros',
        'Defeitos nas caixas suecas',
        'Defeitos na célula de pressão total',
        'Outro',
    ],
    Sinalização: [
        'Placa tombada',
        'Ausência de placa de identificação',
        'Identificação ilegível',
        'Ausência de placas de rota de fuga',
        'Outro',
    ],
} as const;

type RecomendacaoProps = {
    uuid_barregem: string,
    data_inspecao: string,
    changeRecomendacoes: (data: any) => void;
    data: any;
    editPlano: boolean;
}

export default function Recomendacoes({ uuid_barregem, data_inspecao, changeRecomendacoes, data, editPlano }: RecomendacaoProps) {

    const [recomendacoes, setRecomendacoes] = useState<Recomendacao[]>([]);
    const [dialog, setDialog] = useState<boolean>(false);
    const [baseDados, setBaseDados] = useState<any>();

    //armazena o valor da estrutura e anomalia atualmente selecionada
    const [estrutura, setEstrutura] = useState<Estrutura | ''>('');
    const [itemAnomalia, setItemAnomalia] = useState<string>('');
    const [item2Anomalia, setItem2Anomalia] = useState<string>('');
    const [codigo2Anomalia, setCodigo2Anomalia] = useState<string>('');

    // Estados temporários para o formulário do dialog
    const [tempSituacao, setTempSituacao] = useState<string>('');
    const [tempMagnitude, setTempMagnitude] = useState<string>('');
    const [tempNPA, setTempNPA] = useState<string>('');

    //armazena o index para controle da referencia para a anomalia 
    const [indexAnomalia, setIndexAnomalia] = useState<number | null>(null);

    function addPlano() {
        setRecomendacoes(prev => [
            ...prev,
            {
                prazo: '',
                recomendacao: '',
                plano_acao: {
                    acao: '',
                    data_limite_seguranca: '',
                    npa: '',
                    responsavel_principal: '',
                    descricao: '',
                    finalizado: false,
                    codigo_anomalia: '',
                    id_barragem: uuid_barregem,
                    status: 'NAO INICIADO'
                }
            }
        ]);
    }

    function removePlano(index: number) {
        setRecomendacoes(prev => prev.filter((_, i) => i !== index));
    }

    function changeDialogStats(index: number | null) {
        if (index !== null) {
            const anomaliaAtual = recomendacoes[index]?.plano_acao?.anomalia;
            if (anomaliaAtual) {
                setItemAnomalia(anomaliaAtual.item || '');
                setItem2Anomalia(anomaliaAtual.item || '');
                setTempSituacao(anomaliaAtual.situacao || '');
                setTempMagnitude(anomaliaAtual.magnitude || '');
                setTempNPA(anomaliaAtual.npa || '');
                setCodigo2Anomalia(anomaliaAtual.codigo_anomalia || '');
                // Buscar a estrutura pelo UUID
                const estruturaEncontrada = baseDados?.find(
                    (item: any) => item.uuid === anomaliaAtual.id_estrutura
                );
                setEstrutura(estruturaEncontrada?.estrutura || '');
            }
        } else {
            setEstrutura('');
            setItemAnomalia('');
            setItem2Anomalia('');
            setTempSituacao('');
            setTempMagnitude('');
            setTempNPA('');
            setCodigo2Anomalia('');
        }
        setIndexAnomalia(index);
        setDialog(prev => !prev);
    }

    const onChange = (index: number, path: keyof Recomendacao, valor: any) => {
        setRecomendacoes(prev =>
            prev.map((item, i) =>
                i === index ? { ...item, [path]: valor } : item
            )
        );
    };

    const onChangePlano = (index: number, path: keyof PlanoAcao, valor: any) => {
        setRecomendacoes(prev =>
            prev.map((item, i) => {
                if (i !== index) return item;

                if (!item.plano_acao) {
                    return {
                        ...item,
                        plano_acao: {
                            acao: '',
                            data_limite_seguranca: '',
                            npa: '',
                            responsavel_principal: '',
                            descricao: '',
                            finalizado: false,
                            codigo_anomalia: '',
                            id_barragem: uuid_barregem,
                            [path]: valor
                        }
                    };
                }

                return {
                    ...item,
                    plano_acao: { ...item.plano_acao, [path]: valor }
                };
            })
        );
    };

    const salvarAnomalia = () => {
        if (indexAnomalia === null) return;

        if (!estrutura || !itemAnomalia || !tempSituacao || !tempMagnitude || !tempNPA) {
            alert('Por favor, preencha todos os campos da anomalia');
            return;
        }

        const estruturaSelecionada = baseDados?.find(
            (item: { estrutura: string; }) => item.estrutura === estrutura
        );

        if (!estruturaSelecionada) {
            alert('Estrutura não encontrada no banco de dados');
            return;
        }

        setRecomendacoes(prev =>
            prev.map((item, i) => {
                if (i !== indexAnomalia) return item;

                if (!item.plano_acao) {
                    return {
                        ...item,
                        plano_acao: {
                            acao: '',
                            data_limite_seguranca: '',
                            npa: '',
                            responsavel_principal: '',
                            descricao: '',
                            finalizado: false,
                            codigo_anomalia: '',
                            id_barragem: uuid_barregem,
                            anomalia: {
                                data_inspecao: data_inspecao,
                                item: item2Anomalia !== '' ? item2Anomalia : itemAnomalia,
                                situacao: tempSituacao,
                                magnitude: tempMagnitude,
                                npa: tempNPA,
                                id_barragem: uuid_barregem,
                                id_estrutura: estruturaSelecionada.uuid,
                                observacoes_gerais: '',
                                fluxo: '',
                                origem: 'rpsb',
                                codigo_anomalia: codigo2Anomalia,
                            }
                        }
                    };
                }

                return {
                    ...item,
                    plano_acao: {
                        ...item.plano_acao,
                        anomalia: {
                            data_inspecao: data_inspecao,
                            item: item2Anomalia !== '' ? item2Anomalia : itemAnomalia,
                            situacao: tempSituacao,
                            magnitude: tempMagnitude,
                            npa: tempNPA,
                            id_barragem: uuid_barregem,
                            id_estrutura: estruturaSelecionada.uuid,
                            observacoes_gerais: '',
                            fluxo: '',
                            codigo_anomalia: codigo2Anomalia,
                            data_criacao: new Date().toISOString(),
                            origem: 'rpsb',
                        }
                    }
                };
            })
        );
        changeDialogStats(null);
    };

    async function getBaseDados() {
        const res = await ReportsServicesRpsb.getAnomalias(uuid_barregem);
        if (res instanceof Error) {
            alert('Erro ao buscar base de anomalias!');
        } else {
            setBaseDados(res.anomalias);
        }
    }

    useEffect(() => {
        if (data && data.length > 0) {
            const estado = data as Recomendacao[];
            const novo_estado = estado.map((item) => ({
                ...item,
                prazo: item.prazo?.split(' ')[0] || '',
                plano_acao: item.plano_acao ? {
                    ...item.plano_acao,
                    data_limite_seguranca: item.plano_acao.data_limite_seguranca?.split(' ')[0] || '',
                } : {
                    acao: '',
                    data_limite_seguranca: '',
                    npa: '',
                    responsavel_principal: '',
                    descricao: '',
                    finalizado: false,
                    codigo_anomalia: '',
                    id_barragem: uuid_barregem,
                }
            }));
            setRecomendacoes(novo_estado);
        }
        getBaseDados();
    }, []);

    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        changeRecomendacoes(recomendacoes);
    }, [recomendacoes]);

    console.log(recomendacoes);

    return (
        <Box>
            <Typography variant='h5'>Recomendações</Typography>
            <Divider />

            <Box>
                {recomendacoes.map((item, index) => (
                    <Box
                        key={index}
                        sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}
                    >
                        <TextField
                            label='Prazo'
                            fullWidth
                            type='date'
                            value={item.prazo}
                            InputLabelProps={{ shrink: true }}
                            onChange={e => onChange(index, 'prazo', e.target.value)}
                            // disabled={editPlano}
                        />

                        <TextField
                            // disabled={editPlano}
                            label='Recomendação'
                            fullWidth
                            value={item.recomendacao}
                            InputLabelProps={{ shrink: true }}
                            rows={2}
                            multiline
                            onChange={e => onChange(index, 'recomendacao', e.target.value)}
                            sx={{ gridColumn: 'span 2', gridRow: 'span 2' }}
                        />

                        <Box sx={{ gridColumn: 'span 2' }}><Divider /></Box>

                        
                        <TextField
                            disabled={item.uuid ? true : false}
                            label='Data limite de segurança'
                            fullWidth
                            type='date'
                            value={item.plano_acao?.data_limite_seguranca || ''}
                            InputLabelProps={{ shrink: true }}
                            onChange={e => onChangePlano(index, 'data_limite_seguranca', e.target.value)}
                        />
                        <FormControl disabled={item.uuid ? true : false}>
                            <InputLabel>Ação</InputLabel>
                            <Select
                                value={item.plano_acao?.acao || ''}
                                onChange={e => onChangePlano(index, 'acao', e.target.value)}
                            >
                                <MenuItem value={'MC - Monitoramento/Controle'}>MC - Monitoramento/Controle</MenuItem>
                                <MenuItem value={'RE - Reparo/Eliminação'}>RE - Reparo/Eliminação</MenuItem>
                                <MenuItem value={'CL - Conservação/Limpeza'}>CL - Conservação/Limpeza</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl fullWidth disabled={item.uuid ? true : false}>
                            <InputLabel>NPA</InputLabel>
                            <Select
                                value={item.plano_acao?.npa || ''}
                                onChange={e => onChangePlano(index, 'npa', e.target.value)}
                            >
                                <MenuItem value="Normal">Normal</MenuItem>
                                <MenuItem value="Atenção">Atenção</MenuItem>
                                <MenuItem value="Alerta">Alerta</MenuItem>
                                <MenuItem value="Emergência">Emergência</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            disabled={item.uuid ? true : false}
                            label='Responsável'
                            fullWidth
                            value={item.plano_acao?.responsavel_principal || ''}
                            InputLabelProps={{ shrink: true }}
                            onChange={e => onChangePlano(index, 'responsavel_principal', e.target.value)}
                        />
                        <TextField
                            disabled={item.uuid ? true : false}
                            label='Descrição'
                            fullWidth
                            value={item.plano_acao?.descricao || ''}
                            InputLabelProps={{ shrink: true }}
                            onChange={e => onChangePlano(index, 'descricao', e.target.value)}
                            sx={{ gridColumn: 'span 2' }}
                        />

                        {/* Mostrar informações da anomalia vinculada APENAS se existir */}
                        {item.plano_acao.anomalia?.item && (
                            <Box sx={{ gridColumn: 'span 2', p: 1, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                <Typography variant='caption' color='text.secondary'>
                                    <strong>Anomalia vinculada:</strong> {item.plano_acao.anomalia.item} -
                                    Situação: {item.plano_acao.anomalia.situacao} -
                                    Magnitude: {item.plano_acao.anomalia.magnitude}
                                </Typography>
                            </Box>
                        )}

                        <Box sx={{ width: '100%', display: 'flex', gap: 2 }}>
                            <Button onClick={() => changeDialogStats(index)} variant='contained' startIcon={<Link />} disabled={item.uuid ? true : false}>
                                {item.plano_acao.anomalia?.item ? 'Editar anomalia' : 'Vincular anomalia'}
                            </Button>
                            <Button onClick={() => removePlano(index)} variant='text' color='error' startIcon={<Remove />}>
                                Remover
                            </Button>
                        </Box>
                    </Box>
                ))}

                <Button onClick={addPlano} variant='outlined' startIcon={<Add />} fullWidth style={{ marginTop: 15 }} >
                    Adicionar
                </Button>
            </Box>

            <Dialog open={dialog} fullWidth maxWidth="md">
                <DialogTitle>Cadastro de anomalia</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 4, paddingTop: 2, justifyContent: 'space-between' }}>
                        <FormControl fullWidth>
                            <InputLabel>Estrutura</InputLabel>
                            <Select
                                value={estrutura}
                                onChange={(e) => {
                                    setEstrutura(e.target.value as Estrutura);
                                    setItemAnomalia('');
                                }}
                            >
                                {baseDados?.map((item: any) => (
                                    <MenuItem value={item.estrutura} key={item.uuid}>
                                        {item.estrutura}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth disabled={estrutura === ''}>
                            <InputLabel>Anomalia</InputLabel>
                            <Select
                                value={itemAnomalia}
                                disabled={estrutura === ''}
                                onChange={(e) => setItemAnomalia(e.target.value)}
                            >
                                {estrutura !== '' &&
                                    anomaliasType[estrutura]?.map((value, index) => (
                                        <MenuItem key={index} value={value}>
                                            {value}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                        {itemAnomalia === 'Outro' && (
                            <TextField
                                label='Nome da anomalia'
                                fullWidth
                                value={item2Anomalia}
                                InputLabelProps={{ shrink: true }}
                                onChange={e => setItem2Anomalia(e.target.value)}
                            />
                        )}
                    </Box>

                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel>Situação</InputLabel>
                            <Select
                                value={tempSituacao}
                                onChange={(e) => setTempSituacao(e.target.value)}
                            >
                                <MenuItem value="NE">Não existente (NE)</MenuItem>
                                <MenuItem value="NI">Não Inspecionado (NI)</MenuItem>
                                <MenuItem value="PV">1ª Ocorrência (PV)</MenuItem>
                                <MenuItem value="RE">Recorrente (RE)</MenuItem>
                                <MenuItem value="PC">Constante (PC)</MenuItem>
                                <MenuItem value="TR">Tratada (TR)</MenuItem>
                                <MenuItem value="AU">Aumentou (AU)</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl fullWidth>
                            <InputLabel>Magnitude</InputLabel>
                            <Select
                                value={tempMagnitude}
                                onChange={(e) => setTempMagnitude(e.target.value)}
                            >
                                <MenuItem value="Insignificante">Insignificante</MenuItem>
                                <MenuItem value="Pequeno">Pequeno</MenuItem>
                                <MenuItem value="Médio">Médio</MenuItem>
                                <MenuItem value="Grande">Grande</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl fullWidth>
                            <InputLabel>NPA</InputLabel>
                            <Select
                                value={tempNPA}
                                onChange={(e) => setTempNPA(e.target.value)}
                            >
                                <MenuItem value="Normal">Normal</MenuItem>
                                <MenuItem value="Atenção">Atenção</MenuItem>
                                <MenuItem value="Alerta">Alerta</MenuItem>
                                <MenuItem value="Emergência">Emergência</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            label='Código de identificação da anomalia'
                            fullWidth
                            value={codigo2Anomalia}
                            InputLabelProps={{ shrink: true }}
                            onChange={e => setCodigo2Anomalia(e.target.value)}
                        />
                    </Box>

                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-around', marginTop: 2 }}>
                        <Button startIcon={<Cancel />} sx={{ borderColor: 'red', color: 'red' }} variant='outlined' onClick={() => changeDialogStats(null)}>
                            Cancelar
                        </Button>
                        <Button startIcon={<Save />} variant='contained' onClick={salvarAnomalia}>
                            Salvar
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </Box>
    );
}
